import React,{forwardRef, useRef, useImperativeHandle } from 'react'
import {Tabs,Tab} from 'react-bootstrap'
import GDSForm from './patientdata/gds/gds'
import Scopa_aut from './patientdata/scopa_aut/scopa_aut'
import Sas from './patientdata/SAS/sas'
import Fab from './patientdata/FAB/fab'
import Moca from './patientdata/moca/moca'
import Seadl from './patientdata/seadl/seadl'
import Hoehn_yahr from './patientdata/hoehn_yarh/hoehn_yarh'
import Umsars from './patientdata/umsars/umsars'
import PspDs from './patientdata/PSP-DS/psp-ds'
import Updrs from './patientdata/UPDRS/updrs'
import Psp from './patientdata/psp/psp'
import PDQ from './patientdata/PDQ/pdq'
import RBDQS from "./patientdata/RBDQS/rbdqs"
import ImagingBiomarkers from "../components/patientdata/imaging_biomarkers/ImagingBiomarkers"
import ClinicalAndDiagnosis from "../components/patientdata/ClinicalCriteriaAndDiagnosis/ClinicalAndDiagnosis"
import ClinicalCriteria from "./patientdata/ClinicalCriteriaAndDiagnosis/DiagnosticCriteria/clinicalcriteria"
import CurrentTreatment from  "../components/patientdata/demographics/currentTreatment"
import NMSS from "./patientdata/NMSS/nmss";
import Cgi from "./patientdata/CGI/cgi";
import {Container,Button,Modal} from 'react-bootstrap'
import app from "../login/firebase";
import axios from "axios";
import { useParams, useRouteMatch,Route,Switch} from "react-router-dom";
import MMSE from "./patientdata/mmse/mmse";
import CISI from "./patientdata/CISI/cisi";
import IPAQ from './patientdata/IPAQ/ipaq'
import MEDAS from './patientdata/MEDAS/medas'
import GCF_TMT from './patientdata/GCF_TMT/gcf_tmt'
class Visit extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            mounted:false,
            data:{}
        }
    }
    async componentDidMount() { 
        await this.setState({data:this.props.data,mounted:true}) //mounting data passed from edit patients to visit 
    }
    handleImaging = async (income_state) =>{ // handle Image and Biomarkers component
       
        await  this.setState(prevState=>({data:{...prevState.data,...income_state}}))

        console.log(this.state.data)
    }
    handleChangeDirect = async(field,event)=>{ //changing state directily without recieving changes state from child
        // const form  = event.currentTarget
        const {name,value} = event.target
        await this.setState((prevState)=>(
            {
                ...prevState,
                   data:{
                       ...prevState.data,
                        [field]:{
                            ...prevState.data[field],
                            [name] : value
                        }
                    }
                }
            
        ))
    }
    handleChange = async (field,income_state) => { //change state .receives child state
        await this.setState((prevState)=>(
            {   
                ...prevState,
                data:{

                
                    ...prevState.data,
                  
                    [field]:{...prevState.data[field],...income_state}
                }
            }
        ))
        
    }
    handleChangeWithObject =  async(field,object) =>{
        await this.setState((prevState)=>(
           { ...prevState,
            data:{
            ...prevState.data,
            [field]:object
            }
        }
        ))
    }
    
    getVisitNo = () =>{
        return this.props.visitNo
    }
    componentDidUpdate(prevProps,prevState){
        if(prevState.data!=this.state.data){
            if(!this.props.preventEdit){
               // if edit mode is triggered pass new updated state to parent 
                this.props.handleVisitUpdate(this.state.data,this.props.visitNo)
            }
        }
    }
    handleClinicalPspMsa  = async(field,event)=>{
        // const form  = event.currentTarget
       
       
        if(event.target){
            var {name,value} = event.target
        }
        else{
            var {name,value} = event //articial event
        }
       
         this.setState((prevState)=>(
            {
                ...prevState,
                    
                       data:{
                            ...prevState.data,
                            [field]:{
                                ...prevState.data[field],
                                [name] : value
                            }
                    }
                }
            
        ))
        
    }
    
    render(){
        
        

        if(this.state.mounted){
            const data = this.state.data
            return (
                <div>
                    {/* <Button onClick={this.submitChange}>Submit</Button> */}
                    <Tabs defaultActiveKey={'diagnosis_diagnostic_criteria'}  >
                        
                            {/* <Tab eventKey={'clinical_criteria'} title={"Diagnostic Criteria"}>
                                <ClinicalCriteria handler={this.handleChange} 
                                data={{"clinical_psp":this.props.data['clinical_psp'],"clinical_msa":this.props.data['clinical_msa'],"clinical_parkinson_disease":this.props.data['clinical_parkinson_disease'],"unclassified_parkinsonism":this.props.data['unclassified_parkinsonism']}} 
                                disabled={this.props.preventEdit} />
                            </Tab> */}
                            <Tab eventKey={'diagnosis_diagnostic_criteria'} title={"Diagnosis and Diagnostic Criteria"}  mountOnEnter={true}>
                                <ClinicalAndDiagnosis handler={this.handleChangeWithObject} handler1={this.handleChangeDirect} handlePspMsaAuto={this.handleClinicalPspMsa}
                                data={
                                    {"clinical_psp":data['clinical_psp'],"clinical_msa":data['clinical_msa'],"clinical_parkinson_disease":data['clinical_parkinson_disease'],"diagnosis":data['diagnosis'],
                                    "unclassified_parkinsonism":data['unclassified_parkinsonism']
                                    ,"umsars_new":data['umsars_new'],"medical_notes":data['medical_notes']}}
                                    disabled={this.props.preventEdit}
                                />
                            </Tab>
                            <Tab eventKey={'current_treatment'} title={"Current Treatment"} mountOnEnter={true}>
                                <CurrentTreatment data={this.props.data!=null? this.props.data["current_treatment"]:null} disabled={this.props.preventEdit }handler={this.handleChangeDirect}/>
                            </Tab>
                            
                            <Tab eventKey={'hoehn_yahr'} title={'H&Y'} mountOnEnter={true}>
                                <Hoehn_yahr handler={this.handleChange} data={data['hoehn_yahr']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'updrs'} title={'UPDRS-IV'} mountOnEnter={true}>
                                <Updrs handler={this.handleChange}data={data['updrs']} mountOnEnter={true} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'psp'} title={'PSP-RS'} mountOnEnter={true}>
                                <Psp handler={this.handleChange} data={data['psp']} mountOnEnter={true} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'psp-ds'} title={'PSP-CDS '} mountOnEnter={true}>
                                <PspDs handler={this.handleChange} data={data['psp_cds']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'umsars'} title={'UMSARS'} mountOnEnter={true}>
                                <Umsars handler={this.handleChange} data={data['umsars']} disabled={this.props.preventEdit} />
                            </Tab>
                            <Tab eventKey={'gds'} title={'GDS'} mountOnEnter={true}>
                                <GDSForm handler={this.handleChange} data={data['gds']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'scopa_aut'} title={'SCOPA-AUT'} mountOnEnter={true}>
                                <Scopa_aut handler={this.handleChange} gender={data['gender']}data={data['scopa_aut']} disabled={this.props.preventEdit} />
                            </Tab>
                            <Tab eventKey={'sas'} title={'SAS'} mountOnEnter={true}>
                                <Sas handler={this.handleChange} data={data['sas']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'fab'} title={'FAB'} mountOnEnter={true}>
                                <Fab handler={this.handleChange} data={data['fab']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'moca'} title={'MOCA'} mountOnEnter={true}>
                                <Moca handler={this.handleChange} data={data['moca']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'seadl'} title={'SEADL'} mountOnEnter={true}>
                                <Seadl handler={this.handleChange} data={data['seadl']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'rbdsq'} title={'RBDSQ'} mountOnEnter={true}>
                                <RBDQS handler={this.handleChange} data={data['rbdsq']} mountOnEnter={true} disabled={this.props.preventEdit} />

                            </Tab>
                            
                            
                            
                        
                            <Tab eventKey={'PDQ'} title={'PDQ-8'}>
                                <PDQ handler={this.handleChange} data={data['pdq']} mountOnEnter={true} disabled={this.props.preventEdit}/>

                            </Tab>
                        
                            <Tab eventKey={'imaging_biomarkers'} title={"Imaging and Biomarkers"}>
                                <ImagingBiomarkers 
                                handler={this.handleImaging} 
                                mountOnEnter={true} 
                                data={{"bmri":this.props.data['bmri'],
                                datscan:this.props.data['datscan'],
                                ibzm_spect:this.props.data['ibzm_spect'],
                                mibg_spect:this.props.data['mibg_spect'],
                                polysomnography:this.props.data['polysomnography'],
                                fdg_pet_brain:this.props.data['fdg_pet_brain'],
                                "serum_sample":this.props.data['serum_sample'],
                                "csf_sample":this.props.data['csf_sample'],
                                "pmbcs_exosomes":this.props.data['pmbcs_exosomes']}} 
                                disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'nmss'} title={'NMSS'} mountOnEnter={true}>
                                <NMSS handler={this.handleChange} data={data['nmss']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'mmse'} title={"MMSE"} mountOnEnter={true}>
                                <MMSE handler={this.handleChange} data={data['mmse']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'cgi'} title={"CGI"} mountOnEnter={true}>
                                <Cgi handler={this.handleChange} data={data['cgi']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'CISI'} title={"CISI"} mountOnEnter={true}>
                                <CISI handler={this.handleChange} data={data['cisi']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'IPAQ'} title={"IPAQ"} mountOnEnter={true}>
                                <IPAQ handler={this.handleChange} data={data['ipaq']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'MEDAS'} title={"MEDAS"} mountOnEnter={true}>
                                <MEDAS handler={this.handleChange} data={data['medas']} disabled={this.props.preventEdit}/>
                            </Tab>
                            <Tab eventKey={'gcf_tmt'} title={"GCF / TMT"} mountOnEnter={true}>
                                <GCF_TMT handler={this.handleChange} data={data['gcf_tmt']} disabled={this.props.preventEdit}/>
                            </Tab>
                        </Tabs>
                </div>
            )
        }
        else{
            return(
                <div>
                    Loading
                </div>
            )
        }
    }
}

export default forwardRef((props,ref)=><Visit ref={ref} {...props}/>) // forward ref to access